module.exports = __webpack_public_path__ + "static/media/kepler.a24aadc2.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/kepler.webp
// module id = 583
// module chunks = 0